import { createContext } from "react";

export type SystemContextType = {};

const SystemContext = createContext<Partial<SystemContextType>>({});

export default SystemContext;
